import React, { useState } from 'react';
import { useNavigate } from 'react-router-dom';
import { Container, Row, Col, Form, Button, Alert, Card } from 'react-bootstrap';
import axios from 'axios';
import './Register.css';
import { authService } from '../../services/api';

const Register = () => {
  const [formData, setFormData] = useState({
    email: '',
    username: '',
    first_name: '',
    last_name: '',
    password: '',
    password2: ''
  });
  const [error, setError] = useState('');
  const [loading, setLoading] = useState(false);
  const navigate = useNavigate();

  const handleChange = (e) => {
    setFormData({
      ...formData,
      [e.target.name]: e.target.value,
    });
  };

  const handleSubmit = async (e) => {
    e.preventDefault();
    setLoading(true);
    setError('');

    if (formData.password !== formData.password2) {
      setError('Les mots de passe ne correspondent pas');
      setLoading(false);
      return;
    }

    try {
      // Include first_name and last_name in the registration request
      const response = await authService.register(
        formData.username,
        formData.email,
        formData.password,
        formData.first_name,
        formData.last_name
      );
      
      const loginResponse = await authService.login(formData.email, formData.password);
      

      localStorage.setItem('access_token', loginResponse.data.access);
      localStorage.setItem('refresh_token', loginResponse.data.refresh);
      axios.defaults.headers.common['Authorization'] = `Bearer ${loginResponse.data.access}`;
      
      // Notify about authentication change
      window.dispatchEvent(new Event('authChange'));
      
      navigate('/subscription');
    } catch (err) {
      // Improve error handling to show more specific errors
      if (err.response?.data) {
        // Format validation errors from the API
        const errorMessages = [];
        for (const field in err.response.data) {
          errorMessages.push(`${field}: ${err.response.data[field].join(', ')}`);
        }
        setError(errorMessages.join('\n') || 'L\'inscription a échoué. Veuillez réessayer.');
      } else {
        setError('L\'inscription a échoué. Veuillez réessayer.');
      }
    } finally {
      setLoading(false);
    }
  };

  return (
    <div className="register-page">
      <Container>
        <Row className="justify-content-center">
          <Col md={8} lg={6}>
            <Card className="register-card">
              <Card.Body>
                <div className="text-center mb-4">
                  <h2 className="register-title">Créer un compte</h2>
                  <p className="register-subtitle">Rejoignez-nous pour accéder à tous nos services</p>
                </div>
                
                {error && (
                  <Alert variant="danger">
                    {error}
                  </Alert>
                )}
                
                <Form onSubmit={handleSubmit}>
                  <Row>
                    <Col md={6}>
                      <Form.Group className="mb-3">
                        <Form.Label>Nom d'utilisateur</Form.Label>
                        <div className="input-group">
                          <span className="input-group-text">
                            <i className="fas fa-user"></i>
                          </span>
                          <Form.Control
                            type="text"
                            name="username"
                            placeholder="Choisissez un nom d'utilisateur"
                            value={formData.username}
                            onChange={handleChange}
                            required
                          />
                        </div>
                      </Form.Group>
                    </Col>
                    <Col md={6}>
                      <Form.Group className="mb-3">
                        <Form.Label>Email</Form.Label>
                        <div className="input-group">
                          <span className="input-group-text">
                            <i className="fas fa-envelope"></i>
                          </span>
                          <Form.Control
                            type="email"
                            name="email"
                            placeholder="Entrez votre email"
                            value={formData.email}
                            onChange={handleChange}
                            required
                          />
                        </div>
                      </Form.Group>
                    </Col>
                  </Row>


                  <Row>
                    <Col md={6}>
                      <Form.Group className="mb-3">
                        <Form.Label>Prénom</Form.Label>
                        <div className="input-group">
                          <span className="input-group-text">
                            <i className="fas fa-user"></i>
                          </span>
                          <Form.Control
                            type="text"
                            name="first_name"
                            placeholder="Entrez votre prénom"
                            value={formData.first_name}
                            onChange={handleChange}
                            required
                          />
                        </div>
                      </Form.Group>
                    </Col>
                    <Col md={6}>
                      <Form.Group className="mb-3">
                        <Form.Label>Nom</Form.Label>
                        <div className="input-group">
                          <span className="input-group-text">
                            <i className="fas fa-user"></i>
                          </span>
                          <Form.Control
                            type="text"
                            name="last_name"
                            placeholder="Entrez votre nom"
                            value={formData.last_name}
                            onChange={handleChange}
                            required
                          />
                        </div>
                      </Form.Group>
                    </Col>
                  </Row>
                  <Row>
                    <Col md={6}>
                      <Form.Group className="mb-3">
                        <Form.Label>Mot de passe</Form.Label>
                        <div className="input-group">
                          <span className="input-group-text">
                            <i className="fas fa-lock"></i>
                          </span>
                          <Form.Control
                            type="password"
                            name="password"
                            placeholder="Créez un mot de passe"
                            value={formData.password}
                            onChange={handleChange}
                            required
                          />
                        </div>
                      </Form.Group>
                    </Col>
                    <Col md={6}>
                      <Form.Group className="mb-4">
                        <Form.Label>Confirmer le mot de passe</Form.Label>
                        <div className="input-group">
                          <span className="input-group-text">
                            <i className="fas fa-lock"></i>
                          </span>
                          <Form.Control
                            type="password"
                            name="password2"
                            placeholder="Confirmez votre mot de passe"
                            value={formData.password2}
                            onChange={handleChange}
                            required
                          />
                        </div>
                      </Form.Group>
                    </Col>
                  </Row>
                  
                  <Button 
                    variant="primary" 
                    type="submit" 
                    className="w-100 register-btn" 
                    disabled={loading}
                  >
                    {loading ? 'Création en cours...' : 'Créer mon compte'}
                  </Button>
                  
                  <div className="text-center mt-4">
                    <p className="mb-0">
                      Vous avez déjà un compte? <a href="/login" className="register-link">Se connecter</a>
                    </p>
                  </div>
                </Form>
              </Card.Body>
            </Card>
          </Col>
        </Row>
      </Container>
    </div>
  );
};

export default Register;
